<template>
  <div class="card">
    <div class="card-header" @click="toggle = !toggle">
      <h5 class="mb-0 ml-0">
        <a class="btn btn-link">
          <i class="fas fa-cube"></i>
          <strong class="titulo">ALTERADO {{ alteracao.categoria }} {{ data }}</strong>
          <span style="float:right; margin-right: 0px; line-height:0">
            <!-- - {{ item.hora }}-->
            <span class="icone fs-20" v-if="!toggle">
              <i class="fas fa-plus"></i>
            </span>
            <span class="icone fs-20" v-if="toggle">
              <i class="fas fa-minus"></i>
            </span>
          </span>
          <span></span>
        </a>
      </h5>
    </div>
    <transition name="exibir">
      <div v-if="toggle">
        <div class="card-body">
          <b v-if="alteracao.categoria == 'PISCOFINS'">
            Redação atual:
            <div v-html="alteracao.piscofins"></div>
          </b>
          <b v-else>Aliquota atual:</b>
          <div v-html="alteracao.aliquota"></div>
          <br />
          <b>Descrição da alteração:</b>
          {{ alteracao.observacao }}
          <hr class="hr" v-if="alteracao.anterior" />
          <b v-if="alteracao.categoria == 'PISCOFINS' && alteracao.anterior">Redação anterior:</b>
          <b v-if="alteracao.categoria != 'PISCOFINS' && alteracao.anterior">Aliquota anterior:</b>
          <span v-html="alteracao.anterior" class="ml-1"></span>
          <span v-if="alteracao.anterior && alteracao.categoria != 'PISCOFINS'">%</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    alteracao: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      toggle: false,
      data: ""
    };
  },
  created() {
    this.data = this.alteracao.data.substring(0, 10);
  }
};
</script>

<style scoped>
.card-header {
  cursor: pointer;
}
.fs-20 {
  font-size: 15px;
  color: gray;
}
.icone {
  width: 10px;
  padding-right: 10px;
  margin-left: 10px;
  display: inline-block;
}

.exibir-enter,
.exibir-leave-to {
  min-height: 0;
  max-height: 0;
  opacity: 0;
}

.exibir-enter-to,
.exibir-leave {
  min-height: 1;
  max-height: 400px;
  opacity: 1;
}

.exibir-leave-active,
.exibir-enter-active {
  transition: all 0.4s;
}

.card-body {
  color: #777;
}

.titulo {
  font-weight: bold;
}

.hr {
  margin: 10px 0;
}
</style>